import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'
import NotFound from 'src/components/GeneralViews/NotFoundPage.vue'
import Auth from 'src/components/Auth/routes'
import Stands from './Stands/routes'
import Admin from './Admin/routes'
import EventDashboardLayout from './Components/DashboardLayout'
import Lottery from './Lottery/routes'
import store from '../../store'

const routes = [
  ...Auth,
  ...Admin,
  {
    path: '/',
    name: 'index',
    meta: {
      checkPermissions ({user, from, to, authResult, next, $auth}) {
        let newRoute = null
        if (user === null) {
          newRoute = {name: 'stands-index', params: {eventUri: 'Куриный-король-2019'}}
        } else if (user.isSuperuser) {
          newRoute = {name: 'manage-root'}
        } else {
          const {brands, events, stands} = user.permissions
          if (brands.length > 0) {
            debugger
            // next({name: })
          } else if (events.length > 0) {
            debugger
          } else if (stands.length > 0) {
            newRoute = {name: 'stands-index', params: {eventUri: stands[0].event.uri}}
          }
        }
        if (newRoute) {
          next(newRoute)
          return true
        } else {
          return false
        }
      },
      auth: true
    }
  },
  {
    path: '/event/:eventUri',
    name: 'event-root',
    component: EventDashboardLayout,
    meta: {
      auth: true,
    },
    children: [
      ...Stands,
    ]
  },
  ...Lottery,
  {path: '*', component: NotFound}
]
export default routes
